import { IAppGlobalConfig, IServerConfig } from './../app.store.interface';
import { HttpClient } from '@angular/common/http';

export class AppGlobalConfigAction {
    constructor(
        private getState: () => IAppGlobalConfig,
        private setState: (newState: IAppGlobalConfig) => void,
        private http: HttpClient) {
      }
    
      setLoading = (show: boolean) => {
        this.setState({ ...this.getState(), isLoading: show });
      }
    
      //=======================================================
      //actions que mutan el estado
      //=======================================================
    
      getGlobalBegin = () => {
        this.setState({ ...this.getState(), isLoading: true, error: false });
      };
    
      getGlobalConfigSuccess = (configuration: IServerConfig) => {
        this.setState({ ...this.getState(), isLoading: false, error: false, configuration: configuration });
      };
    
      getGlobalConfigError = () => {
        this.setState({ ...this.getState(), isLoading: false, error: true });
      };

    //=======================================================
    //async actions
    //=======================================================

      asyncGetGlobalConfig = () => {
        this.getGlobalBegin();
        return new Promise((resolve, reject) => {
          this.http.get<IServerConfig>('/api/Configuration/ConfigurationData').subscribe(config => {
            setTimeout(() => {
              this.getGlobalConfigSuccess(config);
              resolve();
            });
          }, error => {
            setTimeout(() => {
              this.getGlobalConfigError();
              reject();
            });
          });
        });
      }
}